import { SIGN_IN, SIGN_OUT, SET_LOADER } from './actions';
import { setCookie } from 'utils/cookies';
import Utils, { getPostLoginRedirectPath } from 'utils/utils';

const defaultState = {
  loader: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case SIGN_IN: {
      setCookie('email', action.profile.email);
      window.location.href = window.location.origin + getPostLoginRedirectPath(action.isCmsOnlyUser);
      return { ...state, user: action.profile, token: action.token, loggedIn: true }; // handling user info from Google
    }
    // return { ...state };
    case SIGN_OUT: {
      document.cookie = '';
      Utils.reAuthenticate();
      return { ...state, user: {}, token: null, loggedIn: false };
    }
    case SET_LOADER:
      return { ...state, loader: !state.loader };
    default:
      return state;
  }
}

export const getUser = (state) => state.app;
export const getLoader = (state) => state.app.loader;
